import { GridApiCommon } from '../../../models/api/gridApiCommon'

/**
 * Get the summed width of all the visible columns.
 * @category Visible Columns
 */
export const gridColumnsTotalWidthSelector = (apiRef: GridApiCommon) => {
  return (
    apiRef.tableInstance.getCenterTotalSize() +
    apiRef.tableInstance.getLeftTotalSize() +
    apiRef.tableInstance.getRightTotalSize()
  )
}

export const gridColumnsTotalPinnedWidthSelector = (apiRef: GridApiCommon) => {
  return (
    apiRef.tableInstance.getLeftTotalSize() +
    apiRef.tableInstance.getRightTotalSize()
  )
}

export const gridColumnCenterWidthSelector = (apiRef: GridApiCommon) => {
  return apiRef.tableInstance.getCenterTotalSize()
}

export const gridColumnLeftWidthSelector = (apiRef: GridApiCommon) => {
  return apiRef.tableInstance.getLeftTotalSize()
}

export const gridColumnCenterCount = (apiRef: GridApiCommon) => {
  return apiRef.tableInstance.getCenterVisibleLeafColumns().length
}

export const gridColumnCenterCellSize =
  (apiRef: GridApiCommon) => (index: number) => {
    return (
      apiRef.tableInstance.getCenterVisibleLeafColumns()[index]?.getSize() ?? 0
    )
  }
